module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_5.c64c59f4.pdf";